import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';
import { ReportingDocumentType } from '../../utils/enums';
import ErrorDocumentDetailForm from '../errorDocumentDetail/ErrorDocumentDetailForm';
import SAPDocumentTypeRVErrorDetailForm from '../errorDocumentDetail/SAPDocumentTypeRVErrorDetailForm';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import XmlDataViewer from '../documentViewers/xml/XmlDataViewer';

const MODAL_CLASSNAMES =  {
    modal: 'modal-full-width-height modal-max-width-75'
};

class ErrorDetailsModal extends React.Component {

    
    render() {
        let errorDetails = this.props.errorDetails || {};
        let documentViewerComponent = (<div></div>);
        switch(errorDetails.reportingDocumentType) {
            case ReportingDocumentType.TYPE_1:
            case ReportingDocumentType.INTRASTAT_DOCUMENT_TYPE:
                documentViewerComponent = (
                    <ErrorDocumentDetailForm 
                        errorDetail={errorDetails} 
                        submitHandler={this.props.onSubmit}
                        onProcessed={this.props.onProcessed}
                    />
                );
                break;
            case ReportingDocumentType.SAP_DOCUMENT_TYPE_RV:
                documentViewerComponent = (
                    <SAPDocumentTypeRVErrorDetailForm 
                        errorDetail={errorDetails} 
                        submitHandler={this.props.onSubmit}
                        onProcessed={this.props.onProcessed}
                    />
                );
                break;
            case ReportingDocumentType.UNKNOWN:
            default:
                documentViewerComponent = (
                  <div className="invoice-container">
                    <h2>{errorDetails.errorMessage}</h2>
                      <div><LanguageStringResolver string='errorDocumentDetail_Unknown_Help'/></div>
                        <p/>
                      <div><span className="uppercase"><LanguageStringResolver string='errorDocumentDetail_Unknown_Document'/>:</span> {errorDetails.documentName}</div>
                        <p/>
                      <XmlDataViewer xml={errorDetails.xml} />
                  </div>
                );
                break;
        }
        return(
            <div>
                <Modal 
                    classNames={MODAL_CLASSNAMES}                    
                    open={this.props.open} 
                    onClose={this.props.onClose} 
                    closeOnEsc={true} 
                    blockScroll={true}
                    closeOnOverlayClick={false} 
                    center 
                >
                    { documentViewerComponent  }
                </Modal>
            </div>
        );
    }
}


ErrorDetailsModal.defaultProps = {
    onClose: () => {},
    errorDetails: {},
    onSubmit: () => {},
    onProcessed: () => {}
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(ErrorDetailsModal);
